import { COOKIES_SUCCESS, CookiePreferences } from './types';

// action creators
export const cookiesSuccessAction = (config: CookiePreferences) => {
    return {
        payload: config,
        type: COOKIES_SUCCESS,
    };
};
